// 登录截止时间：2026年10月30日 00:00:00 (北京时间)
// 在此日期之前使用工具不需要登录，之后必须登录
const LOGIN_DEADLINE = new Date('2026-10-30T00:00:00+08:00')

export function isLoginRequired() {
  return new Date() >= LOGIN_DEADLINE
}
